import { PageKey } from '@core/enums/page-keys.enum';
import { VisitStatus } from '@core/enums/visit-status.enum';
import { FlowId, type CheckinWorkflow } from '../workflow-engine.types';
import { exportControlValidationFlow } from './export-control-validation.flow';

export enum QrCodeValidationStep {
  Scan = 'Scan',
  Validate = 'Validate',
  Failure = 'Failure',
  DryPrecheckInFailure = 'DryPrecheckInFailure',
  AfterExportControl = 'AfterExportControl',
}

export const qrCodeValidationFlow: CheckinWorkflow<QrCodeValidationStep> = {
  id: FlowId.QrCodeValidation,
  entry: QrCodeValidationStep.Scan,
  steps: {
    [QrCodeValidationStep.Scan]: {
      id: QrCodeValidationStep.Scan,
      page: PageKey.QR_CODE_READER,
      next: () => ({ nextStep: QrCodeValidationStep.Validate }),
      back: () => ({ bubble: 'back' }),
      exit: () => ({ bubble: 'exit' }),
    },
    [QrCodeValidationStep.Validate]: {
      id: QrCodeValidationStep.Validate,
      page: PageKey.QR_CODE_READER_VALIDATION,
      next: (variables) => {
        if (!variables.isScanQrCodeValidationSuccess) {
          return {
            nextStep:
              variables.visitStatus === VisitStatus.DRY_PRECHECKED_IN
                ? QrCodeValidationStep.DryPrecheckInFailure
                : QrCodeValidationStep.Failure,
          };
        }

        return variables.checkinProcessConfiguration?.hasExportControl === true
          ? {
              flow: exportControlValidationFlow,
              returnStep: QrCodeValidationStep.AfterExportControl,
            }
          : { complete: true };
      },
      back: () => ({ bubble: 'back' }),
      exit: () => ({ bubble: 'exit' }),
    },
    [QrCodeValidationStep.Failure]: {
      id: QrCodeValidationStep.Failure,
      page: PageKey.QR_CODE_READER_FAIL,
      next: () => ({ bubble: 'exit' }),
      back: () => ({ nextStep: QrCodeValidationStep.Scan }),
      exit: () => ({ bubble: 'exit' }),
    },
    [QrCodeValidationStep.DryPrecheckInFailure]: {
      id: QrCodeValidationStep.DryPrecheckInFailure,
      page: PageKey.QR_CODE_READER_FAIL_DRY_PRECHECK_IN,
      next: () => ({ bubble: 'exit' }),
      back: () => ({ nextStep: QrCodeValidationStep.Scan }),
      exit: () => ({ bubble: 'exit' }),
    },
    [QrCodeValidationStep.AfterExportControl]: {
      id: QrCodeValidationStep.AfterExportControl,
      next: () => ({ complete: true }),
    },
  },
};
